module.exports = __webpack_public_path__ + "img/refferal-invite.499aa5b7.svg";